import Item from 'src/models/Item';
import {
  getCategory,
  getInsurancePackage,
  checkBpTsaCancer,
  createOrder,
  getVouchers,
  applyVoucher as requestApplyVoucher,
  checkDiscount,
} from 'src/api';
import { ProductCode } from 'src/constants';
import InsurancePackage from 'src/models/InsurancePackage';
import { makeAutoObservable, runInAction } from 'mobx';
import LoadingService from 'src/utils/LoadingService';
import PopupService from 'src/utils/PopupService';
import i18n from 'src/lang/i18n';
import CancerFormInfo from 'src/models/CancerFormInfo';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import UserInfoService from 'src/utils/UserInfoService';
import Voucher from 'src/models/Voucher';
import InsuranceDiscountInfo from 'src/models/InsuranceDiscountInfo';

dayjs.extend(customParseFormat);
export class CancerStore {
  questions: Item[] = [];
  commitments: Item[] = [];
  nationalitys: Item[] = [];
  insurancePackages: InsurancePackage[] = [];
  vouchers: Voucher[] = [];
  formInfo: CancerFormInfo;
  insuranceDiscountInfo?: InsuranceDiscountInfo;
  applNo?: string;
  policyNumber?: string;
  constructor() {
    makeAutoObservable(this);
  }

  cleanFormInfo() {
    this.formInfo = null;
  }

  updateFormInfo(data: any) {
    if (!this.formInfo) {
      this.formInfo = data;
    } else {
      this.formInfo = {
        ...this.formInfo,
        ...data,
      };
    }
  }

  get selectedPackage() {
    return this.insurancePackages?.find(
      (item) => item.id == this.formInfo?.choosedInsurancePackage
    );
  }

  get selectedVoucher() {
    return this.vouchers?.find(
      (item) => item.voucherCode == this.formInfo?.voucherCode
    );
  }

  async fetchCategory() {
    try {
      const categoryRes = await getCategory(ProductCode.CANCER);
      console.log('categoryRes', categoryRes?.data);
      runInAction(() => {
        this.questions = categoryRes?.data?.questions;
        this.commitments = categoryRes?.data?.commitments;
        this.nationalitys = categoryRes?.data?.nationalitys;
      });
    } catch (err) {
      console.log('getCategory err', err);
    }
  }

  async fetchInsurancePackage(
    dob: string,
    gender: 'MALE' | 'FEMALE' | undefined,
    nationality: string,
    history: any
  ) {
    try {
      LoadingService.instance.current.open();
      const insurancePackageResponse = await getInsurancePackage(
        dob,
        gender,
        nationality
      );
      console.log('insurancePackageResponse', insurancePackageResponse);
      const nationList = this.nationalitys;
      const nationCode = nationList.find((item) => item.name == nationality)
        ?.id;
      runInAction(() => {
        this.formInfo = {
          birthDate: dayjs(dob, 'DD/MM/YYYY').toDate(),
          gender,
          nationality: nationCode,
        };
        this.insurancePackages = insurancePackageResponse?.data?.list;
      });
      // yield put(setInsurancePackage(insurancePackageResponse?.data?.list));
      history.push('/buy-insurance/cancer/benefit-packages');
    } catch (err) {
      console.log(
        'getInsurancePackage err',
        err?.response,
        err?.response?.status
      );
      if (
        err?.response?.status == 400 &&
        (err?.response?.data?.error_code == 'MSGMBAL' ||
          err?.response?.data?.error_code == 'MSGMBAL-CONVERT')
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          cancelTitle: i18n.t('later'),
          showContactButton: true,
          hotline: i18n.t('hotline2'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          onCancel: () => {
            PopupService.instance.current.close();
          },
        });
      } else if (
        err?.response?.status == 400 &&
        err?.response?.data?.error_code == 'invalid-param'
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: i18n.t('general_error'),
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
      } else if (err?.response?.status == 400) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          okTitle: i18n.t('close'),
          showIcon: false,
          onOk: () => {
            PopupService.instance.current.close();
          },
        });
      }
    } finally {
      LoadingService.instance.current.close();
    }
  }

  async fetchCheckBpTsa(
    choosedPackage: string,
    sumAssured: number,
    history: any
  ) {
    try {
      LoadingService.instance.current.open();
      const checkBpResponse = await checkBpTsaCancer(
        sumAssured,
        UserInfoService.getUserInfo()?.idCardNo,
        UserInfoService.getUserInfo()?.fullname,
        dayjs(this.formInfo.birthDate).format(i18n.t('date_format1')),
        this.formInfo.gender
      );
      runInAction(() => {
        this.formInfo = {
          ...this.formInfo,
          choosedInsurancePackage: choosedPackage,
        };
      });

      console.log('checkBpResponse', checkBpResponse);
      // const vouchersResponse = await getVouchers();
      // console.log('vouchersResponse: ', vouchersResponse);
      // runInAction(() => {
      //   this.formInfo = {
      //     ...this.formInfo,
      //     choosedInsurancePackage: choosedPackage,
      //   };
      //   this.vouchers = vouchersResponse.data?.list;
      // });
      // history.push(
      //   !vouchersResponse?.data?.list ||
      //     vouchersResponse?.data?.list?.length == 0
      //     ? '/buy-insurance/cancer/health-question'
      //     : '/cancer/voucher'
      // );
      history.push('/buy-insurance/cancer/health-question');
    } catch (err) {
      console.log('checkBpResponse err', err?.response, err?.response?.status);
      if (
        err?.response?.status == 400 &&
        err?.response?.data?.error_code == 'MSGMBAL'
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          cancelTitle: i18n.t('later'),
          showContactButton: true,
          hotline: i18n.t('hotline2'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          onCancel: () => {
            PopupService.instance.current.close();
          },
        });
      } else if (
        err?.response?.status == 400 &&
        err?.response?.data?.error_code == 'invalid-param'
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: i18n.t('general_error'),
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
      } else if (err?.response?.status == 400) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
        });
      }
    } finally {
      LoadingService.instance.current.close();
    }
  }

  async fetchCheckBpTsaForPayment(
      choosedPackage: string,
      sumAssured: number,
      history: any
  ) {
    try {
      LoadingService.instance.current.open();
      await checkBpTsaCancer(
          sumAssured,
          UserInfoService.getUserInfo()?.idCardNo,
          UserInfoService.getUserInfo()?.fullname,
          dayjs(this.formInfo.birthDate).format(i18n.t('date_format1')),
          this.formInfo.gender
      );
      runInAction(() => {
        let formInfo = this.formInfo;
        this.formInfo = {
          ...formInfo,
          choosedInsurancePackage: choosedPackage,
        };
      });
    } catch (err) {
      console.log('checkBpResponse err', err?.response, err?.response?.status);
      if (
          err?.response?.status == 400 &&
          err?.response?.data?.error_code == 'MSGMBAL'
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          cancelTitle: i18n.t('later'),
          showContactButton: true,
          hotline: i18n.t('hotline2'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          onCancel: () => {
            PopupService.instance.current.close();
          },
        });
      } else if (
          err?.response?.status == 400 &&
          err?.response?.data?.error_code == 'invalid-param'
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: i18n.t('general_error'),
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
      } else if (err?.response?.status == 400) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
        });
      }
      throw err;
    } finally {
      LoadingService.instance.current.close();
    }
  }

  async applyVoucher(voucherCode: string, history: any): Promise<boolean> {
    let isSucess: boolean;
    try {
      LoadingService.instance.current.open();
      const applyVoucherResponse = await requestApplyVoucher(
        this.formInfo?.choosedInsurancePackage,
        +this.selectedPackage.premiumAm,
        voucherCode
      );

      console.log('applyVoucherResponse', applyVoucherResponse);
      runInAction(() => {
        this.formInfo = {
          ...this.formInfo,
          voucherCode: voucherCode,
        };
        this.insuranceDiscountInfo = applyVoucherResponse.data;
      });
      isSucess = true;
    } catch (err) {
      console.log('applyVoucher err', err?.response, err?.response?.status);

      if (
        err?.response?.status == 400 &&
        err?.response?.data?.error_code == 'MSG-VOUCHER'
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('invalid_vouhcer_code'),
          content: err?.response?.data?.error_message,
          cancelTitle: i18n.t('later'),
          onCancel: () => {
            PopupService.instance.current.close();
          },
          onOk: () => {
            PopupService.instance.current.close();
          },
          showContactButton: true,
          showIcon: true,
          hotline: i18n.t('hotline2'),
        });
      } else if (
        err?.response?.status == 400 &&
        err?.response?.data?.error_code == 'invalid-param'
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: i18n.t('general_error'),
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
      } else if (err?.response?.status == 400) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
        });
      }
      isSucess = false;
    } finally {
      LoadingService.instance.current.close();
    }
    return isSucess;
  }

  cancelApplyDiscount() {
    runInAction(() => {
      this.insuranceDiscountInfo = null;
      this.formInfo = {
        ...this.formInfo,
        discountCode: null,
      };
    });
  }

  async applyDiscount(discount: string) {
    // try {
    LoadingService.instance.current.open();
    const applyDiscountRes = await checkDiscount({
      insurancePackageId: this.selectedPackage.id,
      insamountAm: +this.selectedPackage.insamountAm,
      discount: discount,
      dob: dayjs(this.formInfo.birthDate).format(i18n.t('date_format1')),
      gender: this.formInfo?.gender,
      idCardNo: UserInfoService?.getUserInfo()?.idCardNo,
    });
    console.log('checkdiscount res', applyDiscountRes);
    runInAction(() => {
      this.formInfo = {
        ...this.formInfo,
        discountCode: discount,
      };
      this.insuranceDiscountInfo = applyDiscountRes.data;
    });
    LoadingService.instance.current.close();
  }

  async cancelAppplyVoucher(): Promise<boolean> {
    runInAction(() => {
      this.insuranceDiscountInfo = null;
      this.formInfo = {
        ...this.formInfo,
        voucherCode: null,
      };
    });
    return true;
  }

  confirmInfo(email: string, address: string, history: any) {
    runInAction(() => {
      this.formInfo = {
        ...this.formInfo,
        address,
        email,
      };
    });
    history.push('/buy-insurance/cancer/customer-commitment');
  }

  requestCreateOrder = async (referralCode: string, history: any) => {
    try {
      LoadingService.instance.current.open();
      const createOrderResponse = await createOrder({
        dob: dayjs(this.formInfo.birthDate).format(i18n.t('date_format1')),
        gender: this.formInfo?.gender,
        fullname: UserInfoService.getUserInfo()?.fullname,
        amount: this.insuranceDiscountInfo
          ? this.insuranceDiscountInfo?.afterDiscount
          : +this.selectedPackage.premiumAm,
        premium: +this.selectedPackage.premiumAm,
        sumInsured: +this.selectedPackage.insamountAm,
        idCardNo: UserInfoService?.getUserInfo()?.idCardNo,
        mobile: UserInfoService.getUserInfo()?.mobile,
        email: this.formInfo.email,
        nationality: this.nationalitys.find(
          (item) => item.id == this.formInfo.nationality
        )?.name,
        address: this.formInfo.address,
        introduceCode: referralCode || null,
        voucherCode:
          this.selectedVoucher?.voucherCode ||
          this.formInfo.discountCode ||
          null,
      });
      console.log('createOrderResponse', createOrderResponse?.data);
      if (createOrderResponse?.data?.hasFree) {
        runInAction(() => {
          this.applNo = createOrderResponse?.data?.applNo;
          this.policyNumber = createOrderResponse?.data?.policyNumber;
        });

        history.push('/buy-insurance/cancer/release-policy');
      } else {
        if (window?.ReactNativeWebView) {
          window?.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: 'PAYMENT_HUB_TRANSACTION',
              data: createOrderResponse?.data?.transactionSimpleDto,
            })
          );
        }
      }
    } catch (err) {
      console.log('createOrder err', err?.response, err?.response?.status);
      if (
        err?.response?.status == 400 &&
        err?.response?.data?.error_code == 'invalid-param'
      ) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: i18n.t('general_error'),
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
      } else if (err?.response?.status == 400) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          okTitle: i18n.t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
      }
    } finally {
      LoadingService.instance.current.close();
    }
  };
}

export default new CancerStore();
